// Utility function for building eyebrows from Seeen's video objects
// Eyebrow bits are added to Seen's UI as Categories (which are referenced by their API as "internalTags")
export function getEyebrowFromTags(internalTags) {
  const defaultEyebrow = 'Fast Company';
  if (!Array.isArray(internalTags)) return defaultEyebrow;

  const eventDate = internalTags.find(tag => tag.value.includes('EVENTDATE'));
  const eventName = internalTags.find(tag => tag.value.includes('EVENTNAME'));
  const eventSponsor = internalTags.find(tag =>
    tag.value.includes('EVENTSPONSOR')
  );

  let eyebrowText;

  // Event date is always added to the eyebrow
  if (eventDate) eyebrowText = eventDate.value.split(': ')[1];

  // Has a sponsor - add sponsor string & return early
  if (eventDate && eventSponsor) {
    eyebrowText += ` | In partnership with ${
      eventSponsor.value.split(': ')[1]
    }`;
    return eyebrowText;
  }

  // No sponsor - add event name string instead
  if (eventDate && eventName) {
    eyebrowText += ` | ${eventName.value.split(': ')[1]}`;
  }

  return eyebrowText || defaultEyebrow;
}
